import React from "react";
import Card from "components/card";
import { 
    LuStar,
} from "react-icons/lu"

const RecognitionCard = ({
    employee,
    description,
    date,
}) => {
    return (
        <Card className="flex flex-col gap-6 rounded-xl border border-amber-200 bg-gradient-to-br from-amber-50 to-white">
            <div className="pb-6 p-4">
                <div className="flex items-start gap-3">
                    <LuStar className="w-5 h-5 text-amber-500 flex-shrink-0 mt-1" />
                    <div className="flex-1">
                        <p className="text-sm font-semibold">
                            {employee}
                        </p>
                        <p className="text-sm text-slate-700 mt-1">
                            {description}
                        </p>
                        <p className="text-xs text-slate-700 mt-2">
                            {date}
                        </p>
                    </div>
                </div>
            </div>
        </Card>
    )
};
export default RecognitionCard;